module.exports = __webpack_public_path__ + "static/FSP-90-422a86da519707e68d449515009350ff.png";